/**
 * Defines a Popper modifier that will set the value of `pvdCurrentPlacement`
 * based on Popper's placement.
 */
function getCurrentPlacementPopperModifier() {
    return {
        name: 'placement',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['flip'],
        fn: ({ state }) => {
            if (this.pvdCurrentPlacement !== state.placement) {
                this.pvdCurrentPlacement = state.placement;
            }
        },
    };
}

export { getCurrentPlacementPopperModifier };
//# sourceMappingURL=get-current-placement-popper-modifier.js.map
